import { z } from "zod";

export enum UploadedFilesTableFields {
  FILE_NAME = "fileName",
  LINE_COUNT = "lineCount",
  DATE = "date",
  MARKET_PLACE = "marketPlace",
  PROGRESS = "progress",
  ENABLE_POWER_UP_DATA = "enablePowerUpData",
  CONDITION = "condition",
  ID_TYPE = "idType",
  ACTIONS = "actions",
}

export const FIELD_REQUIRED_ERR = "Field is required";

export const PageSizeOptions = [10, 20, 50, 100];

export const ROW_HEIGHT = 41;

export const AllowedFileTypes = {
  "text/csv": [".csv"],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
};

export enum AllowedCurrencies {
  USD = "USD",
  EUR = "EUR",
}

export enum AllowedMarketplaces {
  US = "US",
  EU = "EU",
}

export enum AllowedSearchByTerms {
  UPC = "UPC",
  EAN = "EAN",
  ASIN = "ASIN",
  ISBN = "ISBN",
}

export const AMAZON_CREDENTIALS_NOT_ADDED_ERR = "Amazon credentials not added.";

export const fileUploadFormValidationSchema = z.object({
  fileName: z.string().trim().min(1, FIELD_REQUIRED_ERR),
  searchBy: z.nativeEnum(AllowedSearchByTerms, {
    required_error: FIELD_REQUIRED_ERR,
    invalid_type_error: FIELD_REQUIRED_ERR,
  }),
  productIdColumn: z.string({
    required_error: FIELD_REQUIRED_ERR,
    invalid_type_error: FIELD_REQUIRED_ERR,
  }),
  costColumn: z.string({
    required_error: FIELD_REQUIRED_ERR,
    invalid_type_error: FIELD_REQUIRED_ERR,
  }),
  currency: z.nativeEnum(AllowedCurrencies, {
    required_error: FIELD_REQUIRED_ERR,
    invalid_type_error: FIELD_REQUIRED_ERR,
  }),
  marketplace: z.nativeEnum(AllowedMarketplaces, {
    required_error: FIELD_REQUIRED_ERR,
    invalid_type_error: FIELD_REQUIRED_ERR,
  }),
  customColumns: z.array(z.string()).optional(),
});
